import type { StatusPresetMap } from './types'

export type OrderStatus =
  | 'pending'
  | 'confirmed'
  | 'scheduled'
  | 'in_progress'
  | 'completed'
  | 'cancelled'

export const orderEventStatusPresets: StatusPresetMap<OrderStatus> = {
  pending: { label: 'Pending', tone: 'neutral' },
  confirmed: { label: 'Confirmed', tone: 'info' },
  scheduled: { label: 'Scheduled', tone: 'info' },
  in_progress: { label: 'In Progress', tone: 'progress' },
  completed: { label: 'Completed', tone: 'success' },
  cancelled: { label: 'Cancelled', tone: 'critical' },
}
